module.exports = __webpack_public_path__ + "static/media/Edit.1b4caa1c.svg";